import React from "react";
import cn from "classnames";

const Divider = ({addClass, dotted, solid}) => {
  return (
    <div
      className={cn("divider", {
        [addClass]: !!addClass,
        dotted: !!dotted,
        solid: !!solid,
      })}
    ></div>
  );
};

export default Divider;
